export const INVENTORY_CONTENT_CHANGESET_ITEM_KEY = 'INVENTORY_CONTENT_CHANGESET_ITEM';
export const INVENTORY_CONTENT_CHANGESET_ITEM_NAME = 'Inventory content';
